/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Category_TimingInputs */



/**
* | output |
* | --- |
* | "Timing" |
*
* @param {Qc_Category_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_category_timing = /** @type {((inputs?: Qc_Category_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Category_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тайминг")
	if (locale === "es") return /** @type {LocalizedString} */ ("Temporización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Temporização")
	return /** @type {LocalizedString} */ ("Timing")
});